import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Box, Loader } from "@saviynt/design-system";
import { useAuth } from "../contexts/AuthContext";
import { Day0Landing } from "../components/Day0/Day0Landing";
import { hasValidSession } from "../utils/auth";

export const Route = createFileRoute("/")({
  component: Index,
});

/**
 * `/` shows the Day-0 landing only for a genuine first access (empty
 * lastAccessedAt at login) or the DEMO_DAY0 override — see
 * AuthContext.getHomeRoute. A returning user (non-empty lastAccessedAt), or
 * anyone reaching `/` without a fresh first-login signal (refresh, direct
 * visit), is redirected to the dashboard. Unauthenticated users fall through
 * to the __root guard, which redirects to /login.
 */
export function Index() {
  const { isAuthenticated, getHomeRoute } = useAuth();
  const navigate = useNavigate();
  // login beforeLoad may send a valid session to `/` before React auth
  // catches up — treat tokens as signed-in so we don't render a blank page.
  const signedIn = isAuthenticated || hasValidSession();
  const home = signedIn ? getHomeRoute() : "/";

  useEffect(() => {
    if (signedIn && home !== "/") {
      void navigate({ to: home });
    }
  }, [signedIn, home, navigate]);

  if (signedIn && home !== "/") {
    return (
      <Box className="w-full h-screen flex justify-center items-center">
        <Loader kind="loop" format="main" size="medium" color="brand" />
      </Box>
    );
  }

  return signedIn && home === "/" ? <Day0Landing /> : null;
}
